var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDislikeFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8637 11.8052H18.3345V4.44101H14.8637V11.8052Z",
    fill: "#FFB6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88393 15.7466C5.67333 16.7459 6.32141 17.7839 7.2689 18.1055C7.72854 18.2746 8.21499 18.2368 8.62023 18.0975C9.02424 17.9586 9.41074 17.6973 9.65032 17.3385L9.65102 17.3375L12.8096 12.6381H12.8265V12.6129L12.8267 12.6128L12.8265 12.6127V3.6105H12.8264L12.8267 3.61023H5.35517C4.10472 3.61023 3.40046 4.38826 2.86465 5.23726C2.27724 6.16794 1.89531 7.15959 1.61149 8.04284C1.48038 8.45087 1.36841 8.84163 1.26815 9.19179L1.24366 9.27725C1.13534 9.65491 1.04267 9.97283 0.949453 10.2328C0.692204 10.9501 0.773252 11.6645 1.18113 12.2069C1.58359 12.742 2.23997 13.0247 2.96863 13.0247H6.06803C6.13769 13.0247 6.19069 13.0528 6.22316 13.0896C6.25105 13.1212 6.28267 13.1806 6.26802 13.2882L5.88393 15.7466ZM6.97021 12.1972C7.00435 12.2269 7.037 12.2583 7.06803 12.2914L7.07679 12.1945L6.97021 12.1972Z",
    fill: "#FFB6B6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1978 11.5587C19.1978 12.2838 18.61 12.8716 17.8849 12.8716H15.2593C14.5343 12.8716 13.9465 12.2838 13.9465 11.5587V4.69428C13.9465 4.03154 14.4837 3.49428 15.1465 3.49428H17.8849C18.61 3.49428 19.1978 4.08205 19.1978 4.8071V11.5587ZM17.8849 11.7463C17.9885 11.7463 18.0725 11.6623 18.0725 11.5587V4.8071C18.0725 4.70358 17.9885 4.61956 17.8849 4.61956H15.0718V11.5587C15.0718 11.6623 15.1557 11.7463 15.2593 11.7463H17.8849Z",
    fill: "#FFB6B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDislikeFill);
export default __webpack_public_path__ + "static/media/dislike-fill.0bd8c737e42f7d353c40383e5b31fd11.svg";
export { ForwardRef as ReactComponent };